import {
  Bearbeitungsstand,
  bearbeitungsstandToString
} from '../../../api/models/Status/Bearbeitungsstand';
import { Badge } from '@efast_public/fjd-component-library';
import type { BadgeProps } from '@efast_public/fjd-component-library';

export interface BearbeitungsstandBadgeProps {
  readonly bearbeitungsstand: Bearbeitungsstand;
  readonly fjdBadgeSize: BadgeProps['size'];
}

export default function BearbeitungsstandBadge(
  props: BearbeitungsstandBadgeProps
) {
  let variant: BadgeProps['variant'];
  let iconBefore: BadgeProps['iconBefore'];
  let divId: string;
  switch (props.bearbeitungsstand) {
    case Bearbeitungsstand.OFFEN:
      variant = 'neutral';
      divId = `neutral-badge`;
      break;
    case Bearbeitungsstand.INBEARBEITUNG:
      variant = 'inProgress';
      divId = `inProgress-badge`;
      break;
    case Bearbeitungsstand.ABGESCHLOSSEN:
      variant = 'neutral';
      iconBefore = 'locked';
      divId = `neutral-locked-badge`;
      break;
    default:
      return null;
  }

  return (
    <div id={divId}>
      <Badge
        variant={variant}
        label={bearbeitungsstandToString(props.bearbeitungsstand)}
        size={props.fjdBadgeSize}
        iconBefore={iconBefore}
      />
    </div>
  );
}
